import React from 'react'
import PropTypes from 'prop-types'

import styles from './ArticleHeadline.module.scss'

export const ArticleHeadline = ({ headline }) => (
  <h1 className={styles.articleHeadline}>{headline}</h1>
)

ArticleHeadline.propTypes = {
  headline: PropTypes.node,
}
